import * as React from "react"
import { MetadataModel } from "./models"
import RelatedLinks from "../molecules/news/RelatedLinks"
import PageContentWrapper from "../organisms/PageContentWrapper"
import { useContentfulInspectorMode } from "@contentful/live-preview/react"

const EmbeddedMetadata: React.FC<MetadataModel> = ({ relatedLinks, sys }) => {
  const inspectorProps = useContentfulInspectorMode({ entryId: sys?.id })
  return (
    <PageContentWrapper {...inspectorProps({ fieldId: "metadata" })}>
      <RelatedLinks links={relatedLinks ?? {}} />
    </PageContentWrapper>
  )
}

export default EmbeddedMetadata
